
import { put, call, select } from 'redux-saga/effects';

import { selectMsalContext } from '../reducers/auth';
import { getAccessToken } from '../utils/auth';
import { createShowErrorAction } from '../actions/notifications';

const showErrorAction = createShowErrorAction();

export function* getAccessTokenEffect(scopes) {
    const msalContext = yield select(selectMsalContext);
      if (msalContext === undefined || msalContext === null) {
        put(showErrorAction('msalContext not available'));
        return;
      }
  
      const accessTokenRequestData = { account: msalContext.accounts[0], scopes: scopes };
      const accessToken = yield call(getAccessToken, msalContext, accessTokenRequestData);
      return accessToken;
}